import { StaticQuery, graphql } from 'gatsby'
import React from 'react'
import Img from 'gatsby-image'

import { Link } from './localizedlink'
import { gtag } from '../utils'
import { FormattedMessage } from 'react-intl'

const SponsorGold = ({data}) => (
  <StaticQuery
    query={graphql`
      query {
        kaltura: file(relativePath: {eq: "contents/logo_kaltura.png"}){
          childImageSharp{
            fluid{
              ...GatsbyImageSharpFluid
            }
          }
        }
        awhy: file(relativePath: {eq: "contents/logo_awhy.png"}){
          childImageSharp{
            fluid{
              ...GatsbyImageSharpFluid
            }
          }
        }
        skilla: file(relativePath: {eq: "contents/logo_skilla.png"}){
          childImageSharp{
            fluid{
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={staticData => {
      const { title, sponsors } = data;
      const [kaltura, awhy, skilla] = sponsors;
      return (
        <section id="sponsor-gold" className="section media-partner text-center" aria-labelledby="region-sponsor-gold">
          <div className="container">
            <div className="row" data-aos="fade-up">
              <div className="col-sm-10 col-sm-offset-1">
                <h1 id="region-sponsor-gold" className="section__title">{title}</h1>
                <div className="row">
                  <div className="col-sm-4">
                    <a href="https://corp.kaltura.com/company/about/" title={kaltura.title} className="media-partner__logo text-center" target="_blank" rel="noopener noreferrer">
                      <Img fluid={staticData.kaltura.childImageSharp.fluid} alt={kaltura.title} className="partner__img" />
                      <span className="sponsor__name">{kaltura.title}</span>
                      <span className="sponsor__desc">{kaltura.desc}</span>
                    </a>
                  </div>
                  <div className="col-sm-4">
                    <a href="https://www.awhy.it/" title={awhy.title} className="media-partner__logo text-center" target="_blank" rel="noopener noreferrer">
                      <Img fluid={staticData.awhy.childImageSharp.fluid} alt={awhy.title} className="partner__img" />
                      <span className="sponsor__name">{awhy.title}</span>
                      <span className="sponsor__desc">{awhy.desc}</span>
                    </a>
                  </div>
                  <div className="col-sm-4">
                    <a href="https://www.skilla.com/" title={skilla.title} className="media-partner__logo text-center" target="_blank" rel="noopener noreferrer">
                      <Img fluid={staticData.skilla.childImageSharp.fluid} alt={skilla.title} className="partner__img" />
                      <span className="sponsor__name">{skilla.title}</span>
                      <span className="sponsor__desc">{skilla.desc}</span>
                    </a>
                  </div>
                </div>
                <Link to="/evento/#diventa-sponsor" title="diventa-sponsor" className="btn-cta btn-style-3"
                  onClick={() => gtag('event', 'sponsor', { 'event_category': 'partecipa' })}>
                  <FormattedMessage id="diventa-sponsor" />
                </Link>
              </div>
            </div>
          </div>
        </section>
      )
    }}
  />
);

export default SponsorGold;
